import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppButton = () => {
    const whatsappUrl = 'https://wa.me/+918318150076'; // Replace with actual WhatsApp number

    const handleClick = () => {
        // Track event in Google Analytics (GA4 format)
        if (window.gtag) {
            window.gtag("event", "whatsapp_click", {
                event_category: "Engagement",
                event_label: "WhatsApp Button Clicked",
                value: 1, // Optional: Can be used for reporting
            });
        }

        // Push to dataLayer for advanced tracking
        if (window.dataLayer) {
            window.dataLayer.push({
                event: "whatsapp_click",
                category: "Engagement",
                label: "WhatsApp Button Clicked",
            });
        }
    };

    return (
        <>
            {/* WhatsApp Button */}
            <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-32 right-4 mb-5 bg-green-500 text-white p-3 rounded-full shadow-lg hover:bg-green-600 transition duration-300"
                style={{ zIndex: 1000 }}
                onClick={handleClick} // Call the handleClick function on click
            >
                <FaWhatsapp size={24} />
            </a>

            {/* Sticky Box */}
            <div
                className="fixed bottom-20 right-4 text-white px-4 py-2 rounded-lg shadow-md border-flicker animate-slideIn"
                style={{
                    zIndex: 999,
                    backgroundColor: '#ff0000',
                    animation: 'pulse 2s infinite, slideIn 0.5s ease-out',
                }}
            >
                Flats starting
                <br />
                from ₹5999/month
            </div>

            <style jsx>{`
    /* Slide-in animation */
    @keyframes slideIn {
        0% {
            transform: translateX(100%);
            opacity: 0;
        }
        100% {
            transform: translateX(0);
            opacity: 1;
        }
    }

    /* Pulse animation */
    @keyframes pulse {
        0%, 100% {
            box-shadow: 0 0 10px rgba(255, 0, 0, 0.6), 0 0 20px rgba(255, 0, 0, 0.4);
        }
        50% {
            box-shadow: 0 0 15px rgba(255, 0, 0, 0.8), 0 0 30px rgba(255, 0, 0, 0.6);
        }
    }

    /* Hover effect */
    .border-flicker:hover {
        transform: scale(1.05);
        transition: transform 0.3s ease-in-out;
    }
`}</style>
        </>
    );
};

export default WhatsAppButton;
